import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-186" data-mp="1q99znn14pc0q">
      {visible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/30 bg-navy-deep/95 px-4 py-3 backdrop-blur sm:hidden" data-id="element-187" data-mp="1qb2y4f1l8pxn">
          <a href="#pricing" className="flex w-full items-center justify-center rounded-xl bg-gold px-6 py-4 font-display text-base font-extrabold text-navy-deep shadow-lg transition-colors active:scale-[0.98]" data-id="element-188" data-mp="297m6310no7sm">
            💥 QUIERO MI MEGAPACK AHORA
          </a>
        </motion.div>}
    </AnimatePresence>;
}